(function () {
  const WIDGET_HTML_ID = "aussitotbon-widget-tunnel-2023";

  console.log("ENV", import.meta.env);
  const { VITE_ASSETS_BASE_URL, VITE_IMG_BASE_URL, VITE_CARTE_ONLY } = import.meta.env;

  const isModeCarteOnly = VITE_CARTE_ONLY === 'true';
  let assetPrefix = "";
  if (isModeCarteOnly) {
    assetPrefix = "-carte-only";
  }
  const HTML_FILE_URL = `${VITE_ASSETS_BASE_URL}/html.js`;
  const CSS_FILE_URL = `${VITE_ASSETS_BASE_URL}/index-dist${assetPrefix}.css`;
  const JS_FILE_URL = `${VITE_ASSETS_BASE_URL}/index-dist${assetPrefix}.js`;

  const EVENT_ALPINE_INIT = "alpine:init";
  const EVENT_ALPINE_INITIALIZED = "alpine:initialized";
  const EVENT_GOOGLEMAPS_LOAD = "aussitotbon:googlemaps:load";
  const EVENT_STRIPE_SETUP = "aussitotbon:stripe:setup";
  const EVENT_PAYGREEN_LOAD = "aussitotbon:paygreen:load";

  // Fonction pour vérifier qu'une dépendance est chargée
  function waitForGlobal(globalName, timeout = 5000) {
    return new Promise((resolve, reject) => {
      if (window[globalName]) {
        resolve(window[globalName]);
        return;
      }

      const startTime = Date.now();
      const checkInterval = setInterval(() => {
        if (window[globalName]) {
          clearInterval(checkInterval);
          resolve(window[globalName]);
        } else if (Date.now() - startTime > timeout) {
          clearInterval(checkInterval);
          reject(
            new Error(`${globalName} n'est pas disponible après ${timeout}ms`)
          );
        }
      }, 50);
    });
  }

  // Fonction pour corriger les URLs des images
  function fixImageUrls() {
    const images = document.querySelectorAll('img[src^="/"]');

    images.forEach((img) => {
      const relativePath = img.getAttribute("src");
      if (relativePath.startsWith("/")) {
        img.src = VITE_IMG_BASE_URL + relativePath;
      }
    });

    console.log(`${images.length} images corrigées`);
  }
  // Fonction pour charger Alpine.js programmatiquement
  function loadAlpine() {
    return new Promise((resolve, reject) => {
      // Vérifier si Alpine est déjà chargé
      if (typeof Alpine !== "undefined") {
        resolve();
        return;
      }

      const script = document.createElement("script");
      script.src = "https://unpkg.com/alpinejs@3.x.x/dist/cdn.min.js";
      script.defer = true;

      script.onload = () => {
        // Attendre qu'Alpine soit complètement initialisé
        if (typeof Alpine !== "undefined") {
          resolve();
        } else {
          // Alpine peut prendre un moment à s'initialiser
          const checkAlpine = setInterval(() => {
            if (typeof Alpine !== "undefined") {
              clearInterval(checkAlpine);
              resolve();
            }
          }, 50);
        }
      };

      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  // Fonction pour charger un script externe
  function loadScript(src, isModule = false) {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = src;
      // N'ajouter type="module" que si nécessaire
      if (isModule) {
        script.type = "module";
      }
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function loadStyle(href) {
    const styleLink = document.createElement("link");
    styleLink.rel = "stylesheet";
    styleLink.href = href;
    document.head.appendChild(styleLink);
  }
  // Fonction pour charger les styles
  function loadStyles() {
    // Tailwind CSS
    if (!document.querySelector('script[src*="tailwindcss"]')) {
      const tailwindScript = document.createElement("script");
      tailwindScript.src = "https://cdn.tailwindcss.com";
      document.head.appendChild(tailwindScript);
    }
  }

  async function fetchAppHTML() {
    try {
      await loadScript(HTML_FILE_URL);
      // Vérifier que le HTML a été chargé
      if (typeof window.getAppHTML === "function") {
        return window.getAppHTML();
      } else {
        console.error(
          `HTML non disponible après chargement de ${HTML_FILE_URL}`
        );
        return null;
      }
    } catch (error) {
      console.error("Erreur lors du chargement du HTML:", error);
      return null;
    }
  }

  // Fonction d'initialisation principale
  async function initializeApp() {
    try {
      // 2. Vérifier la div cible
      const targetDiv = document.getElementById(WIDGET_HTML_ID);
      if (!targetDiv) {
        console.error(`Élément avec id "${WIDGET_HTML_ID}" non trouvé`);
        return;
      }

      // 3. Charger les styles
      loadStyles();
      loadStyle(CSS_FILE_URL);

      // 4. Récupérer et injecter le HTML
      const appHTML = await fetchAppHTML();

      document.addEventListener(EVENT_ALPINE_INIT, async () => {
        console.log(EVENT_ALPINE_INIT);

        try {
          // Charger les dépendances nécessaires pour le store
          await Promise.all([
            loadScript(
              "https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.30.1/moment.min.js"
            ),
            loadScript(
              "https://cdnjs.cloudflare.com/ajax/libs/axios/1.11.0/axios.min.js"
            ),
          ]);
          await waitForGlobal("moment");
          await waitForGlobal("axios");
          console.log("Dépendances chargées");

          // Charger votre fichier main.js ou alpineData
          await loadScript(JS_FILE_URL, true); // Charger en tant que module
          console.log("Scripts de l'application chargés");

          // 8. Initialiser sur la div cible après avoir chargé Alpine et AlpineData
          if (appHTML) {
            targetDiv.innerHTML = appHTML;

            // CORRIGER LES URLs DES IMAGES APRÈS INJECTION
            fixImageUrls();
            // Remove loader when Alpine is ready
            const alpineLoader = document.getElementById("alpineLoader");
            if (alpineLoader) {
              console.log("Removing alpine loader...");
              alpineLoader.remove();
            }

            if (!isModeCarteOnly) {
              // Initialiser les dépendances spécifiques
              document.dispatchEvent(new Event(EVENT_STRIPE_SETUP));
              document.dispatchEvent(new Event(EVENT_GOOGLEMAPS_LOAD));
              document.dispatchEvent(new Event(EVENT_PAYGREEN_LOAD));
            }
          } else {
            targetDiv.innerHTML =
              "<div>Erreur de chargement de l'application</div>";
            return;
          }
          console.log("HTML de l'application injecté");
        } catch (error) {
          console.error("Erreur lors de la configuration du store:", error);
        }
      });
      document.addEventListener(EVENT_ALPINE_INITIALIZED, () => {
        console.log(EVENT_ALPINE_INITIALIZED);
      });

      // 6. Charger Stripe si nécessaire
      if (!window.Stripe || !isModeCarteOnly) {
        await loadScript("https://js.stripe.com/v3/");
      }

      // 1. Charger Alpine.js d'abord
      console.log("Chargement d'Alpine.js...");
      await loadAlpine();

      console.log("Application Alpine initialisée avec succès");
    } catch (error) {
      console.error("Erreur lors de l'initialisation:", error);
    }
  }

  // Démarrer l'initialisation
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeApp);
  } else {
    initializeApp();
  }
})();
